import type { FC, MutableRefObject } from 'react';

import { createContext, useCallback, useContext } from 'react';

type ObservedScrollAreaState = {
  onScroll: (e: React.UIEvent<HTMLDivElement>) => void;
  ref: MutableRefObject<HTMLDivElement | null>;
};

const ObservedScrollAreaContext = createContext<ObservedScrollAreaState>({
  onScroll: () => void 0,
  ref: { current: null },
});
ObservedScrollAreaContext.displayName = 'ObservedScrollAreaContext';

type Props = Omit<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'ref'
>;

const ObservedScrollArea: FC<Props> = ({
  children,
  onScroll: delegateOnScroll,
  ...rest
}) => {
  const { onScroll, ref } = useContext(ObservedScrollAreaContext);
  const onScrollWrapper = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      delegateOnScroll?.(e);
      onScroll(e);
    },
    [delegateOnScroll, onScroll],
  );
  return (
    <div {...rest} onScroll={onScrollWrapper} ref={ref}>
      {children}
    </div>
  );
};

export { ObservedScrollArea, ObservedScrollAreaContext };
